import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  detailsRow: {
    marginBottom: theme.spacing(),
  },
}));

export default styles;
